module.exports = __webpack_public_path__ + "img/db-2.9e9ca603.png";